"use strict";
export default (() => {
  const navbar = document.querySelector("[data-sticky-navbar]");
  if (!navbar)
    return;
  const navbarHeight = navbar.clientHeight;
  const handleStickyNavbar = () => {
    const { offset = 200 } = JSON.parse(navbar.dataset.stickyNavbar || "{}");
    const offsetValue = parseInt(offset, 10);
    if (window.scrollY >= offsetValue && !navbar.classList.contains("navbar-stuck")) {
      document.body.style.paddingTop = `${navbarHeight}px`;
      navbar.classList.add("fixed-top", "navbar-stuck");
    } else if (window.scrollY < offsetValue && navbar.classList.contains("navbar-stuck")) {
      document.body.style.paddingTop = "0";
      navbar.classList.remove("fixed-top", "navbar-stuck");
    }
  };
  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      const later = () => {
        timeout = null;
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };
  window.addEventListener("scroll", debounce(handleStickyNavbar, 5));
  handleStickyNavbar();
})();
